import classNames from 'classnames';
import * as React from 'react';
import {
  Body,
  Heading,
  Icon,
  IconComponentType,
} from 'vet-bones/design-system/components';

interface OrganizationDashboardCardProps {
  icon?: IconComponentType;
  onClick?: () => void;
  subtitle?: string;
  testId?: string;
  title: string;
  value: string;
}

export const OrganizationDashboardCard: React.VFC<OrganizationDashboardCardProps> = ({
  icon,
  onClick,
  subtitle,
  testId,
  title,
  value,
}) => {
  const body = (
    <>
      <div className="organization-dashboard-card-header">
        <Heading size="md" weight="semibold">
          {title}
        </Heading>
        {icon ? <Icon IconComponent={icon} size="md" /> : null}
      </div>
      <div className="organization-dashboard-card-value">
        <Heading size="xl" weight="semibold">
          {value}
        </Heading>
      </div>
      {subtitle ? (
        <Body className="organization-dashboard-card-subtitle" size="md">
          {subtitle}
        </Body>
      ) : null}
    </>
  );

  return onClick ? (
    <div
      className={classNames(
        'organization-dashboard-card',
        'organization-dashboard-card--interactive'
      )}
      data-testid={testId}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      {body}
    </div>
  ) : (
    <div className="organization-dashboard-card" data-testid={testId}>
      {body}
    </div>
  );
};
